import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

/**
 * @Deprecated
 *
 * Use MessageComponent instead
 */
@Component({
  selector: 'flo-no-results',
  templateUrl: './no-results.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoResultsComponent {
  private _resultText: string

  @Input()
  //  Core API does not return quotes for queries, while the BFF does
  set currentQueryText(val: string) {
    if (val) {
      this._resultText = val.includes('"') ? val : `"${val}"`
    } else {
      this._resultText = ''
    }
  }
  get currentQueryText() {
    return this._resultText
  }
  @Input() showCurrentQuery = true
  @Input() noQueryText = 'There are no results for your selection.'
  @Input() noQueryTitle = 'Please try searching different keywords or adjusting your filters.'
  @Input() subtitle = 'No results for'
}
